import "@arco-design/web-react/es/Spin/style";
import _Spin from "@arco-design/web-react/es/Spin";
import "@arco-design/web-react/es/Select/style";
import _Select from "@arco-design/web-react/es/Select";
import React from 'react';
import { useSelector } from 'react-redux';
import { useCompany } from '@/hooks/useCompany';
const Option = _Select.Option;
const CompanySelector = () => {
  const {
    currentCompany,
    companies,
    loading,
    switchCompany
  } = useCompany();
  const {
    userInfo
  } = useSelector(state => state);
  const handleCompanyChange = async value => {
    const companyId = parseInt(value, 10);
    const success = await switchCompany(companyId);
    if (success) {
      window.location.href = '/';
    }
  };
  const displayCompanies = companies || [];
  const currentCompanyId = currentCompany?.id?.toString();
  return /*#__PURE__*/React.createElement(_Spin, {
    loading: loading,
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(_Select, {
    className: "company-selector",
    placeholder: "Select Company",
    value: currentCompanyId,
    onChange: handleCompanyChange,
    style: {
      width: 200
    },
    disabled: displayCompanies.length === 0
  }, displayCompanies.map(company => /*#__PURE__*/React.createElement(Option, {
    key: company.id,
    value: company.id.toString()
  }, company.company_name, " (", company.company_code, ")"))));
};
export default CompanySelector;